jQuery(document).ready(function ($) {

  $('#go-to-subscriptions').click(function (e) {
    e.preventDefault();

    var headerHeight = $('header').outerHeight();
    var offset = headerHeight + 50;

    var scrollPosition = $('#subscription-variation-plans-anchor').offset().top - offset;

    $('html, body').animate({
      scrollTop: scrollPosition
    }, 500);
  });

  $('.subscription-variation-atc-button').on('click', function (e) {
    e.preventDefault();

    // Retrieve the button element that was clicked
    var $button = $(this);
    var originalText = $button.text();
    var variationID = $button.data('variation-id');
    var quantity = 1; // Set quantity as 1 for now

    var data = {
      action: 'woocommerce_add_to_cart',
      product_id: variationID,
      quantity: quantity,
    };

    $.ajax({
      type: 'POST',
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      beforeSend: function () {
        $button.text(pawzler_object.adding_to_cart + '...').prop('disabled', true);
      },
      success: function (response) {
        if (response.error && response.product_url) {
          window.location = response.product_url;
          return;
        }

        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);

        $button.text(originalText).prop('disabled', false);
      },
      error: function () {
        alert('Failed to add the product to the cart.');
        $button.text(originalText).prop('disabled', false);
      }
    });
  });

});
